import { render, staticRenderFns } from "./KpiCards.vue?vue&type=template&id=4ce80fd4&scoped=true"
import script from "./KpiCards.vue?vue&type=script&lang=js"
export * from "./KpiCards.vue?vue&type=script&lang=js"
import style0 from "./KpiCards.vue?vue&type=style&index=0&id=4ce80fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce80fd4",
  null
  
)

export default component.exports